import React, { useMemo } from "react";
import { Toaster } from "sonner";
import Routes from "./Routes";
import { AuthProvider } from "shared/context/AuthContext";
import { UIPreferencesProvider, useUIPreferences } from "shared/context/UIPreferencesContext";

import { App as AntdApp, ConfigProvider, theme as antdTheme } from "antd";
import 'antd/dist/reset.css';

// \u0434\u0435\u0444\u043e\u043b\u0442\u043d\u044b\u0435 brand-\u0446\u0432\u0435\u0442\u0430, \u0441\u0438\u043d\u0445\u0440\u043e\u043d\u0438\u0437\u0438\u0440\u043e\u0432\u0430\u043d\u044b \u0441 --primary \u0432 tokens.css
const DEFAULT_PRIMARY = { light: "#4f46e5", dark: "#818cf8" };

// \u0421\u0432\u044f\u0437\u044b\u0432\u0430\u0435\u0442 antd ConfigProvider (\u0430\u043b\u0433\u043e\u0440\u0438\u0442\u043c + colorPrimary) \u0441 UIPreferencesContext.
function ThemedAntd({ children }) {
  const { prefs, effectiveTheme } = useUIPreferences();

  const theme = useMemo(() => ({
    algorithm: effectiveTheme === "dark" ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: prefs.primaryColor || DEFAULT_PRIMARY[effectiveTheme],
    },
  }), [effectiveTheme, prefs.primaryColor]);

  return (
    <ConfigProvider theme={theme}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}

function MyApp() {
  return (
    <UIPreferencesProvider>
      <ThemedAntd>
        <AuthProvider>
          <Routes />
          <Toaster
            position="top-right"
            richColors
            closeButton
            expand={false}
            duration={4000}
          />
        </AuthProvider>
      </ThemedAntd>
    </UIPreferencesProvider>
  );
}

export default MyApp;
